import { ContactInfo, SocialInfo } from '../types/CommonTypes';

export const contactInfo: ContactInfo = {
  address: 'Amaliegade 45, Mezzanin 1256 København K',
  phone: '+ 45 26 13 61 95',
  email: 'kundeservice@dreamplan.io',
  followText: 'Følg os på:',
};

export const socialInfo: SocialInfo = {
  app: 'https://www.dreamplan.io',
  linkedIn: 'https://www.linkedin.com/company/dreamplan',
  facebook: 'https://www.facebook.com/DreamPlan.io',
  instagram: 'https://www.instagram.com/dreamplan.dk',
};
